<template>
  <div class="m-4">
    <div class="flex flex-row gap-2 items-center my-2">
      <button class="rounded-full bg-paleta-3" @click="volver">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="h-8 w-8 p-1" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
          <path
            fill="currentColor"
            d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
          ></path>
        </svg>
      </button>
      <div class="text-white text-base">Paso 2 >> Seleccionar apuesta</div>
    </div>
    <div class="m-2 text-left">
      <span class="inline-block text-teal-200">{{ leyendaHipodromo }}</span>
    </div>
    <div class="m-2 text-left">
      <span class="inline-block bg-white text-gray-700 rounded-full px-3">Carrera</span>
      <span class="inline-block text-white py-1 px-3">{{ leyendaCarreraSeleccionada }}</span>
    </div>
    <div v-for="tipoApuesta in tiposApuestas" :key="tipoApuesta.id" @click="click(tipoApuesta.id)" class="flex flex-col items-start p-2 bg-teal-500 rounded-md my-1 w-full shadow-xl">
      <div class="text-teal-100 font-bold">{{ tipoApuesta.nombre }}</div>
      <div class="text-sm text-teal-200">{{ tipoApuesta.id }} | P. Max(x$): {{ tipoApuesta.pagoMaximo }} | Valor vale: $ {{ tipoApuesta.valorVale }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
    this.$store.dispatch("cargarTiposApuestas");
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },
    click: function(tipoApuestaId) {
      this.$store.dispatch("tipoApuestaSeleccionada", { tipoApuestaId });
      this.$router.push({ path: "/competidores" });
    }
  },
  computed: {
    ...mapState({
      tiposApuestas: state => {
        const tiposApuestasHabilitados = ["GA", "PL", "TE", "GS", "GT", "EX", "IM", "TR", "CU", "QX", "EC", "IC", "TC", "CC", "QC", "DB", "TP", "PK", "QT", "56", "3E", "4E"];
        return state.apuestaActual.tiposApuestas.filter(c => tiposApuestasHabilitados.includes(c.id));
      },
      leyendaHipodromo: state => state.apuestaActual.carreraSeleccionada.hipodromo,
      leyendaCarreraSeleccionada: state => state.apuestaActual.carreraSeleccionada.numero
    })
  }
};
</script>
